declare const window: any;

function nrInWindow(): Boolean {
  return !!window.newrelic;
}

function isDev(): boolean {
  return process.env.NODE_ENV !== 'production';
}

export function nrPageAction(
  name: string,
  attributes?: Record<string, string> | undefined
): void {
  if (nrInWindow()) {
    // eslint-disable-next-line no-console
    if (isDev()) console.log(name, attributes);
    window.newrelic.addPageAction(name, attributes);
  } else {
    // eslint-disable-next-line no-console
    console.log('Not in window');
  }
}

export function nrError(error: string | Error, attributes: {}) {
  if (nrInWindow()) {
    // eslint-disable-next-line no-console
    if (isDev()) console.log(error, attributes);
    window.newrelic.noticeError(error, attributes);
  }
}
